import { App } from '@gin-betting/core';

export default function isMetaTypeEqualScoreType(
    metaType: App.MetaTypes,
    scoreType: App.ScoreTypes
): boolean {
    switch (metaType) {
        case App.MetaTypes.TYPE_MAP: {
            return scoreType === App.ScoreTypes.TYPE_MAP;
        }

        case App.MetaTypes.TYPE_SET: {
            return [
                App.ScoreTypes.TYPE_GAME_POINTS,
                App.ScoreTypes.TYPE_SET,
            ].includes(scoreType);
        }

        case App.MetaTypes.TYPE_INNING: {
            return [
                App.ScoreTypes.TYPE_INNING_OUTS,
                App.ScoreTypes.TYPE_INNING_POINTS,
            ].includes(scoreType);
        }

        case App.MetaTypes.TYPE_QUARTER: {
            return scoreType === App.ScoreTypes.TYPE_QUARTER;
        }

        case App.MetaTypes.TYPE_OVERTIME: {
            return [
                App.ScoreTypes.TYPE_ROUND_OVERTIME,
                App.ScoreTypes.TYPE_PERIOD_OVERTIME,
                App.ScoreTypes.TYPE_QUARTER_OVERTIME,
            ].includes(scoreType);
        }

        case App.MetaTypes.TYPE_BULLETS: {
            return scoreType === App.ScoreTypes.TYPE_PERIOD_BULLETS;
        }

        case App.MetaTypes.TYPE_PERIOD_REGULAR: {
            return scoreType === App.ScoreTypes.TYPE_PERIOD_REGULAR;
        }

        case App.MetaTypes.TYPE_REGULAR: {
            return scoreType === App.ScoreTypes.TYPE_PERIOD_REGULAR;
        }

        case App.MetaTypes.TYPE_GOLDEN_SET: {
            return scoreType === App.ScoreTypes.TYPE_GOLDEN_SET;
        }

        case App.MetaTypes.TYPE_PERIOD_1ST_HALF: {
            return scoreType === App.ScoreTypes.TYPE_PERIOD_1ST_HALF;
        }

        case App.MetaTypes.TYPE_PERIOD_1ST_EXTRA: {
            return scoreType === App.ScoreTypes.TYPE_PERIOD_1ST_EXTRA;
        }

        case App.MetaTypes.TYPE_PERIOD_2ND_HALF: {
            return scoreType === App.ScoreTypes.TYPE_PERIOD_2ND_HALF;
        }

        case App.MetaTypes.TYPE_PERIOD_2ND_EXTRA: {
            return scoreType === App.ScoreTypes.TYPE_PERIOD_2ND_EXTRA;
        }

        case App.MetaTypes.TYPE_PERIOD_PENALTIES: {
            return scoreType === App.ScoreTypes.TYPE_PERIOD_PENALTIES;
        }

        default: {
            return metaType === (scoreType as any);
        }
    }
}
